// Expiry-day reminder (ISS-029, 3 Nov 2026). From 12:00 IST on the expiry day, every OPEN options trade expiring today is
// listed in a prominent banner: review it and Square Off before the market closes. Display only - expiry / settlement
// nothing is squared off or settled automatically; after the close a trade shows EXPIRED · SETTLEMENT PENDING and is
// settled from its settlement preview (ExpirySettlement.jsx, an explicit confirmation).
import React, { useEffect, useState } from "react";

const FROM_MIN_IST = 12 * 60;                 // 12:00 IST
const OPEN = (s) => !["COMPLETE", "STOPPED", "CLOSED", "DRAFT", "READY"].includes(String(s || "").toUpperCase());

/** {date "YYYY-MM-DD", minutes since midnight} in IST, whatever the browser's zone. */
export function istNow(d = new Date()) {
  const ist = new Date(d.getTime() + (330 + d.getTimezoneOffset()) * 60000);
  const p = (n) => String(n).padStart(2, "0");
  return { date: `${ist.getFullYear()}-${p(ist.getMonth() + 1)}-${p(ist.getDate())}`, minutes: ist.getHours() * 60 + ist.getMinutes() };
}

/** The open trades expiring today, once it is 12:00 IST or later (else []). trades: [{id, underlying, expiry, status, label}] */
export function expiringToday(trades, now = new Date()) {
  const { date, minutes } = istNow(now);
  if (minutes < FROM_MIN_IST) return [];
  return (trades || []).filter((t) => String(t.expiry || "").slice(0, 10) === date && OPEN(t.status));
}

export default function ExpiryDayReminder({ trades, testId = "expiry-day-reminder" }) {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => { const t = setInterval(() => setNow(new Date()), 60000); return () => clearInterval(t); }, []);
  const due = expiringToday(trades, now);
  if (!due.length) return null;
  return (
    <div className="rounded-md border-2 border-amber-500 bg-amber-500/10 px-3 py-2 text-xs space-y-1" role="alert" data-testid={testId}>
      <div className="font-bold text-amber-700 dark:text-amber-400">
        EXPIRY TODAY — {due.length} open options trade{due.length === 1 ? "" : "s"}: review and Square Off before the market closes
      </div>
      <div className="flex flex-wrap gap-x-3 gap-y-0.5">
        {due.map((t) => <span key={t.id} className="mono">{t.underlying} #{String(t.id).slice(0, 8)}{t.label ? ` · ${t.label}` : ""} · {t.status}</span>)}
      </div>
      <div className="text-[var(--term-muted)]">Nothing is squared off or settled automatically: a trade still open after the close shows EXPIRED · SETTLEMENT PENDING until its expiry settlement is confirmed.</div>
    </div>
  );
}
